import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { Pagination } from "@common/pagination/Pagination";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import "./css/TransactionHistoryList.scss";
import { useTransactionHistoryList } from "./hook/useTransactionHistoryList";
import { TransactionHistory } from "./TransactionHistory";

interface IParams {
    accountId: string;
}

export const TransactionsHistoryList = (props: IParams) => {
    const { accountId } = props;
    const monthList = [3, 6, 12];
    const [selectedMonth, setSelectedMonth] = useState(monthList[0]);
    const [currentPage, setCurrentPage] = useState(0);
    // Needs to be declared as undefined since some transactions have an empty string as reference
    const [expandedTransaction, setExpandedTransaction] = useState<string>();
    const { transactionHistoryList, totalPages, getTransactionHistoryState, error } = useTransactionHistoryList({
        month: selectedMonth,
        currentPage,
        accountId,
    });
    const { t } = useTranslation(["payment", "glossary"]);

    return (
        <Fragment>
            <Grid className="transaction__header" container spacing={1}>
                <Grid item>
                    <Typography color="primary" variant="h2">
                        {t("payment:transactionsHistory")}
                    </Typography>
                </Grid>
                <Grid item>
                    <Select
                        aria-label="Select filter"
                        disableUnderline
                        fullWidth
                        id="history-helper"
                        value={selectedMonth}
                        variant="filled"
                        onChange={(event) => setSelectedMonth(parseInt(event.target.value as string))}
                    >
                        {monthList.map((month) => (
                            <MenuItem key={month} value={month}>
                                {t("glossary:lastXMonths", { monthsNumber: month })}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            <Paper className="transaction-table" elevation={2}>
                <HandleErrorAndLoading error={error} isLoading={getTransactionHistoryState.isLoading}>
                    <Table>
                        <TableHead className="transaction-table__header">
                            <TableRow>
                                <TableCell>{t("payment:date")}</TableCell>
                                <TableCell>{t("payment:type")}</TableCell>
                                <TableCell>{t("payment:amount")}</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactionHistoryList.length === 0 && (
                                <TableRow>
                                    <TableCell align="center" colSpan={5}>
                                        <Typography align="center" color="textSecondary" variant="body1">
                                            {t("payment:noTransaction")}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                            {transactionHistoryList.map((transaction) => (
                                <TransactionHistory
                                    expandedTransaction={expandedTransaction}
                                    key={transaction.reference}
                                    setExpandedTransaction={setExpandedTransaction}
                                    transaction={transaction}
                                    month={selectedMonth}
                                />
                            ))}
                        </TableBody>
                    </Table>
                    {transactionHistoryList.length !== 0 && (
                        <Pagination
                            currentPage={currentPage}
                            setCurrentIndex={setCurrentPage}
                            totalPages={totalPages}
                        />
                    )}
                </HandleErrorAndLoading>
            </Paper>
        </Fragment>
    );
};
